import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import "./styles/App.css";
import Dashboard from "./components/Dashboard";
import MainContainer from "./components/MainContainer";
import Details from "./components/Details";
import ImportExport from "./components/ImportExport";
const config = require("./config");

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            movie: "",
            movies: [],
            upcomingMovies: [],
            favorites: [],
            watched: [],
            totalPages: 0,
            currentPage: 0
        };
    }

    changeUserInput = movie => {
        this.setState(state => ({ ...state, movie }));
        console.log(this.state.movie);
    };

    onSubmit = movie => {
        if (movie.length > 0) {
            this.setState(
                { movie: movie },
                this.fetchMovie(
                    config.tmdbAPISearch
                        .replace("TO_SEARCH", movie)
                        .replace("&page=__PAGE_NUM", "")
                )
            );
        } else {
            console.log("Sorry, we can't search for an empty movie title.");
        }
    };

    componentWillMount() {
        localStorage.getItem("watched") &&
            this.setState({
                favorites: JSON.parse(localStorage.getItem("favorites"))
            });

        localStorage.getItem("watched") &&
            this.setState({
                watched: JSON.parse(localStorage.getItem("watched"))
            });
    }

    componentDidMount() {
        this.fetchMovie(
            config.tmdbAPI.replace("__PAGE_NUM", this.state.currentPage || 1)
        );

        this.fetchUpcoming();
    }

    componentWillUpdate(nextProps, nextState) {
        localStorage.setItem("favorites", JSON.stringify(nextState.favorites));
        localStorage.setItem("watched", JSON.stringify(nextState.watched));
    }

    fetchMovie(_apiURL) {
        this.APIURL = _apiURL;

        fetch(this.APIURL)
            .then(resp => resp.json())
            .then(data => {
                const movies = data.results;
                const totalPages = data.total_pages;
                const currentPage = data.page;
                if (movies && movies.length > 0 && totalPages && currentPage) {
                    this.setState(state => ({
                        ...state,
                        ...{
                            movies: movies,
                            totalPages: totalPages,
                            currentPage: currentPage
                        }
                    }));
                    console.log(
                        `Searching for ${this.state.movie} returned ${
                            movies.length
                        } entries.`
                    );
                } else {
                    console.log(
                        `Sorry, the API we use did not return any results for ${
                            this.state.movie
                        }.`
                    );
                }
            });
    }

    fetchUpcoming = () => {
        this.fetchUpcomingMoviesAPIEndpoint =
            config.fetchUpcomingMoviesAPIEndpoint;

        fetch(this.fetchUpcomingMoviesAPIEndpoint)
            .then(resp => resp.json())
            .then(data => {
                if (data.results && data.results.length > 0) {
                    const upcoming_movies = data.results.filter(resultMovie => {
                        return !this.state.movies.some(
                            mov => resultMovie.id === mov.id
                        );
                    });
                    this.setState(state => ({
                        ...state,
                        ...{ upcomingMovies: upcoming_movies }
                    }));
                }
            });
    };

    updateFavorites = movie => {
        const { favorites } = this.state;
        const { id, release_date, poster_path, title, popularity } = movie;
        const _movie = { id, release_date, poster_path, title, popularity };

        if (!favorites.find(fav => fav.id === movie.id)) {
            return this.setState({ favorites: [...favorites, _movie] });
        }
        const newFavoriteList = favorites.filter(fav => fav.id !== _movie.id);
        this.setState({ favorites: newFavoriteList });
    };

    changeTitleTo = title => {
        document.getElementsByTagName("title")[0].innerText =
            title.length > 0 ? title + " | " + config.siteName : "Track Movies";
    };

    // changeMetaData = metadata => {
    //     let metaTags = {
    //         title: metadata.title ? metadata.title : config.siteName,
    //         description: metadata.overview ? metadata.overview : "",
    //         keywords: metadata.title
    //             ? metadata.title
    //                   .toLowerCase()
    //                   .split(" ")
    //                   .join(",") +
    //               ", " +
    //               metadata.release_date
    //             : "Track Movies &copy; 2018",
    //         robots: "index, follow"
    //     };

    //     let twitterCardData = {
    //         "twitter:card": metadata.backdrop_path
    //             ? config.tmdbAPIBackdropLink.replace(
    //                   "BACKDROP_LINK",
    //                   metadata.backdrop_path
    //               )
    //             : config.brokenImages.backdrop,
    //         "twitter:site": "@trackmovies",
    //         "twitter:title":
    //             metadata.title && metadata.release_date
    //                 ? `${metadata.title} (${
    //                       metadata.release_date.split("-")[0]
    //                   })`
    //                 : config.siteName,
    //         "twitter:description": metadata.overview
    //             ? `${metadata.overview.slice(0, 180)}...`
    //             : "",
    //         "twitter:creator": "@trackmovies",
    //         "twitter:image:src": metadata.poster_path
    //             ? config.tmdbAPIPosterLink.replace(
    //                   "POSTER_LINK",
    //                   metadata.poster_path
    //               )
    //             : config.brokenImages.poster
    //     };

    //     let opengraphData = {
    //         "og:title": metadata.title ? metadata.title : config.siteName,
    //         "og:type": "video.movie",
    //         "og:url": metadata.imdb_id
    //             ? `https://www.imdb.com/title/${metadata.imdb_id}`
    //             : "Unknown IMDB ID.",
    //         "og:image": metadata.poster_path
    //             ? config.tmdbAPIPosterLink.replace(
    //                   "POSTER_LINK",
    //                   metadata.poster_path
    //               )
    //             : config.brokenImages.poster,
    //         "og:description": metadata.overview ? metadata.overview : "",
    //         "og:site_name": `Track ${
    //             metadata.title ? metadata.title : "Movies"
    //         }`,
    //         "video:release_date": metadata.release_date
    //             ? metadata.release_date
    //             : "Unknown",
    //         "video:duration": metadata.runtime ? metadata.runtime : "Unknown",
    //         "video:tag": metadata.tagline ? metadata.tagline : ""
    //     };

    //     var metadataToAppend = [];

    //     // Create normal meta tags.
    //     Object.keys(metaTags).forEach(function(key) {
    //         var tempElement = document.createElement("meta");
    //         tempElement.setAttribute("name", key);
    //         tempElement.setAttribute("content", metaTags[key]);
    //         metadataToAppend.push(tempElement);
    //     });

    //     // Create Twitter card data.
    //     Object.keys(twitterCardData).forEach(function(key) {
    //         var tempElement = document.createElement("meta");
    //         tempElement.setAttribute("name", key);
    //         tempElement.setAttribute("content", twitterCardData[key]);
    //         metadataToAppend.push(tempElement);
    //     });

    //     // Create Open Graph meta data.
    //     Object.keys(opengraphData).forEach(function(key) {
    //         var tempElement = document.createElement("meta");
    //         tempElement.setAttribute("property", key);
    //         tempElement.setAttribute("content", opengraphData[key]);
    //         metadataToAppend.push(tempElement);
    //     });

    //     // Append those meta tags to our document's head.
    //     metadataToAppend.forEach(meta => {

    //     });
    // };

    searchFavorites = event => {
        this.setState({ term: event.target.value });
    };

    onPageChange = toPage => {
        if (
            toPage > 0 &&
            toPage <= this.state.totalPages &&
            !this.state.movie
        ) {
            this.setState(state => ({ ...state, ...{ currentPage: toPage } }));

            this.fetchMovie(config.tmdbAPI.replace("__PAGE_NUM", toPage || 1));
        } else if (
            toPage > 0 &&
            toPage <= this.state.totalPages &&
            this.state.movie
        ) {
            this.setState(state => ({
                ...state,
                ...{ currentPage: toPage }
            }));
            this.fetchMovie(
                config.tmdbAPISearch
                    .replace("TO_SEARCH", this.state.movie)
                    .replace("__PAGE_NUM", toPage)
            );
        }
    };

    watchedToggle = movie => {
        if (
            !this.state.watched.find(
                watchedMovie => watchedMovie.id === movie.id
            )
        ) {
            // Add new movie to our watch list.
            const newWatchedMovie = {
                id: movie.id,
                release_date: movie.release_date,
                poster_path: movie.poster_path,
                title: movie.title,
                popularity: movie.popularity,
                timestamp: new Date().toLocaleString()
            };
            const newWatchedMoviesList = this.state.watched;
            newWatchedMoviesList.push(newWatchedMovie);

            this.setState(state => ({
                ...state,
                ...{ watched: newWatchedMoviesList }
            }));
        } else {
            // Remove the movies, if exists.
            const currentWatchedMoviesList = this.state.watched;
            const newWatchedMoviesList = currentWatchedMoviesList.filter(
                watchedMovies => watchedMovies.id !== movie.id
            );
            this.setState(state => ({
                ...state,
                ...{ watched: newWatchedMoviesList }
            }));
        }
    };

    onImported = contentToImport => {
        if (
            contentToImport.hasOwnProperty("favorites") &&
            contentToImport.favorites
        ) {
            const importedFavorites = [
                ...new Set([
                    ...this.state.favorites.filter(
                        fav =>
                            !contentToImport.favorites.some(
                                importedFav => importedFav.id === fav.id
                            )
                    ),
                    ...contentToImport.favorites
                ])
            ];

            this.setState(state => ({
                ...state,
                ...{ favorites: importedFavorites }
            }));
        } else {
            console.log("No Favorites in your imported file.");
        }

        if (
            contentToImport.hasOwnProperty("watched") &&
            contentToImport.watched
        ) {
            const importedWatchedList = [
                ...new Set([
                    ...this.state.watched.filter(
                        watched =>
                            !contentToImport.watched.some(
                                importedWatched =>
                                    importedWatched.id === watched.id
                            )
                    ),
                    ...contentToImport.watched
                ])
            ];

            console.log(importedWatchedList);
            this.setState(state => ({
                ...state,
                ...{ watched: importedWatchedList }
            }));
        } else {
            console.log("No Watched entries in your imported file.");
        }
    };

    clearMyLists = () => {
        const newStates = {
            favorites: [],
            watched: []
        };

        this.setState(state => ({
            ...state,
            ...newStates
        }));
    };

    render() {
        return (
            <Router>
                <div>
                    <Switch>
                        <Route
                            path="/"
                            render={props => (
                                <MainContainer
                                    {...props}
                                    movies={this.state.movies}
                                    favoriteEvent={this.updateFavorites}
                                    favorites={this.state.favorites}
                                    onSearch={this.onSubmit}
                                    totalFavorites={this.state.favorites.length}
                                    totalWatched={this.state.watched.length}
                                    searchKeyUpdate={this.searchKeyUpdate}
                                    titleChange={this.changeTitleTo}
                                    totalPages={this.state.totalPages}
                                    currentPage={this.state.currentPage}
                                    onPageChange={this.onPageChange}
                                    upcomingMovies={this.state.upcomingMovies}
                                    watchedToggle={this.watchedToggle}
                                    watched={this.state.watched}
                                />
                            )}
                            exact
                        />
                        <Route
                            path="/dashboard"
                            render={props => (
                                <Dashboard
                                    {...props}
                                    searchFavorites={this.searchFavorites}
                                    sortMovies={this.sortNew}
                                    favorites={this.state.favorites}
                                    favoriteCallback={this.updateFavorites}
                                    onSearch={this.onSubmit}
                                    totalFavorites={this.state.favorites.length}
                                    totalWatched={this.state.watched.length}
                                    searchKeyUpdate={this.searchKeyUpdate}
                                    titleChange={this.changeTitleTo}
                                    watchedToggle={this.watchedToggle}
                                    watched={this.state.watched}
                                    updateFavorites={this.updateFavorites}
                                    clearMyLists={this.clearMyLists}
                                />
                            )}
                        />

                        <Route
                            path="/details/:movieid"
                            render={props => (
                                <Details
                                    {...props}
                                    onSearch={this.onSubmit}
                                    favorites={this.state.favorites}
                                    totalFavorites={this.state.favorites.length}
                                    totalWatched={this.state.watched.length}
                                    favoriteCallback={this.updateFavorites}
                                    titleChange={this.changeTitleTo}
                                    updateFavorites={this.updateFavorites}
                                    similarMovies={this.state.similarMovies}
                                    watchedToggle={this.watchedToggle}
                                    watched={this.state.watched}
                                    changeMetaData={this.changeMetaData}
                                />
                            )}
                        />
                        <Route
                            path="/importexport"
                            render={props => (
                                <ImportExport
                                    {...props}
                                    onSearch={this.onSubmit}
                                    favorites={this.state.favorites}
                                    watched={this.state.watched}
                                    totalFavorites={this.state.favorites.length}
                                    totalWatched={this.state.watched.length}
                                    favoriteCallback={this.updateFavorites}
                                    titleChange={this.changeTitleTo}
                                    onImported={this.onImported}
                                />
                            )}
                        />
                    </Switch>
                </div>
            </Router>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js